// extracted by mini-css-extract-plugin
export default {"kioskSectionHeader":"KioskInstructionSection_kioskSectionHeader__v-EcH","kioskSectionHeaderIcon":"KioskInstructionSection_kioskSectionHeaderIcon__jdyLw"};